import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 40, scale: 0.99 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterHeading({ number, title, id }) {
  return (
    <FadeUp className="mb-14">
      <div className="flex items-end gap-6 border-b border-white/10 pb-6">
        <span className="font-mono-tech text-[#E5FF00] text-sm tracking-[0.3em]" data-testid={`chapter-${number}-num`}>
          /{number}
        </span>
        <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight" data-testid={`chapter-${number}-title`}>
          {title}
        </h2>
      </div>
    </FadeUp>
  );
}
